// @flow

import type { CreateData } from '@gandi/redux-organization';

import {
  createSequoiaResource,
  type SequoiaResource,
  type SequoiaResourceType,
} from '@gandi/resource/redux';

type ServersResourceType = SequoiaResourceType<{
  postPayload: CreateData,
  patchPayload: { id: string, body: Partial<CreateData> },
}>;

export type ServersResource = SequoiaResource<ServersResourceType>;

export const organizationResource: ServersResource = createSequoiaResource(
  'organization',
  'organizations',
  {
    postPath: 'organization/organizations',
    patchPath: 'organization/organizations/{id}',
  },
);
